import { render, staticRenderFns } from "./assistant-pending-confirm.vue?vue&type=template&id=0da12f2c&scoped=true"
import script from "./assistant-pending-confirm.vue?vue&type=script&lang=js"
export * from "./assistant-pending-confirm.vue?vue&type=script&lang=js"
import style0 from "./assistant-pending-confirm.vue?vue&type=style&index=0&id=0da12f2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da12f2c",
  null
  
)

export default component.exports